import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
class ModelLoader {
    model;
    source;
    _isLoaded;
    _isLoading;
    _loadedAt;
    _error;
    _startedLoadingAt;
    loader;
    /**
     * ModelLoader object, that loads a 3D model and holds the result.
     * @param source the source to the model.
     * @param callback callback function to be executed when the model is loaded.
     * @throws If the model fails to load.
     */
    constructor(source, callback) {
        this.loader = new FBXLoader();
        this.source = source;
        this._loadedAt = null;
        this._isLoaded = false;
        this._isLoading = true;
        this._error = null;
        this._startedLoadingAt = Date.now();
        this.load(source, callback);
    }
    /**
     * Load a 3D model, save the result and set the `loaded` property to `true`.
     * @param source the image source
     * @param callback callback function to be executed when the image is loaded.
     * @throws If the model fails to load.
     */
    load(source, callback) {
        this.loader.load(source, fbx => {
            // fbx.traverse(object => {
            //     object.castShadow = true;
            // });
            this.model = fbx;
            this._isLoaded = true;
            this._isLoading = false;
            this._loadedAt = Date.now();
            callback();
        }, undefined, error => {
            this._isLoading = false;
            this._error = `Failed to load FBX model ${source}: ${error}`;
            throw new Error(this._error);
        });
    }
    get getSource() {
        return this.source;
    }
    get startedLoadingAt() {
        return this._startedLoadingAt;
    }
    get loadedAt() {
        return this._loadedAt;
    }
    get isLoading() {
        return this._isLoading;
    }
    get isLoaded() {
        return this._isLoaded && !!this.model;
    }
    get error() {
        return this._error;
    }
    get getAsset() {
        return this.model;
    }
}
export { ModelLoader };
